import { useQuery } from '@tanstack/react-query';

import type { ExistingSurchargeDateBlock } from '~/types/surcharges';

import ReservationService from '~/services/ReservationService';

import { reservationQueryKeys } from './reservationQueryKeys';

interface RoomRateInfo {
  roomType: { id: string };
  roomRate: { id: string };
}

export function useGetExistingSurchargesByRoomRate(
  propertyId: string,
  selectedRoomRates: Array<RoomRateInfo>,
  enabled: boolean,
) {
  return useQuery({
    queryKey: reservationQueryKeys.existingSurchargesByRoomRate(
      propertyId,
      selectedRoomRates.map((rr) => rr.roomRate.id),
    ),
    queryFn: async () => {
      const results: Record<string, Array<ExistingSurchargeDateBlock>> = {};
      await Promise.all(
        selectedRoomRates.map(async (rr) => {
          const data = await ReservationService.getSurchargeDates(propertyId, rr.roomType.id, rr.roomRate.id);
          results[rr.roomRate.id] = data.result?.dates ?? [];
        }),
      );
      return results;
    },
    enabled,
  });
}
